<template>
        <v-layout row wrap>
            <v-flex xs2 v-for="code in data" :key="code.value">
                <v-flex xs12>
                <qrcode :value="code.value" />
            </v-flex>
            <v-flex xs12><h4>{{code.name}}</h4></v-flex>
            </v-flex>
        </v-layout>
</template>
<script>
import Api from '@/services/Api.js'
import Qrcode from 'vue-qrcode'
export default {
    components: {
    Qrcode
  },
  data(){
      return {
          data: []
      }
  },
  created(){
      this.data=[]
      this.fetchPassiveEquipment()
  },
  methods: {
      async fetchPassiveEquipment(){
          await Api()
          .get('/stockItem')
          .then(async response=>{
              await response.data.map(x=>{
                  this.data.push({name: x.name, value: JSON.stringify({id: x.id, name: x.name, stockTypeId: x.stockTypeId, stockTypeName: x.stockType.name})})
              })
          })
          console.log(this.data)
      }
  }
}
</script>